import { Injectable, OnDestroy } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { FlcControlLayer } from "../flc-control-layer.model";
import { LayerSwitcherService } from "../layerswitcher.service";

@Injectable()
export class LayerControlService implements OnDestroy {

  layers: FlcControlLayer[];
  layerChanged = new Subject<FlcControlLayer>();
  setRasterLayersSubscription: Subscription;

  
  constructor(private lsService: LayerSwitcherService)
  {
    this.setRasterLayersSubscription = this.lsService.setFlcControlLayers.subscribe(layers => {
      this.setLayers(layers);
    })
  }
  
  ngOnDestroy(): void {
    if (this.setRasterLayersSubscription) this.setRasterLayersSubscription.unsubscribe();
  }

  setLayers(layers : FlcControlLayer[])
  {
    if (!layers)
    {
      this.layers = [];
    }
    else
      this.layers = layers;
  }

  getLayers() 
  {
    return this.layers;
  }

  changeLayerState(layer: FlcControlLayer) {
      this.layerChanged.next(layer);
  }  
}
